import { useState } from 'react';

import { initTelemetry } from '../../services/telemetry';

/**
 * Initializes the Faro browser SDK once per page load. Rendered from
 * `pages/_app.tsx` so it applies to every route, the same way the old New
 * Relic Browser agent `<script src="/newlearning.js">` tag in
 * `pages/_document.tsx` did.
 *
 * `useState`'s lazy initializer runs exactly once per mount, matching the
 * singleton-construction pattern `_app.tsx` already uses for Metrics,
 * BackendService and the Unleash client. `initTelemetry` is fire-and-forget
 * (it dynamically imports the SDK), so there's nothing to store from it.
 */
export const TelemetryInit = () => {
  useState(() => {
    initTelemetry();
    return null;
  });
  return null;
};

export default TelemetryInit;
